import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Reset scroll position on page load
if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}
window.scrollTo(0, 0);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
